import CustomQuerySetupWizardApiMetricBuilderStepCommonComponent from 'webapp/components/custom-query/setup/wizard/api-metric-builder/step-common';

export default class CustomQuerySetupWizardApiMetricBuilderStepDimensionComponent extends CustomQuerySetupWizardApiMetricBuilderStepCommonComponent {
	override stepTitle = 'Add a dimension to your metric';
	override stepDescription =
		"Optional: Segment your metric further by adding a dimension. If you'd like to segment your metric by multiple dimensions, choose one to complete during this set up, then begin again and select a different dimension until each desired metric is created. To skip this step, select 'None'.";
}
